import {CIPHER_PREFIX} from './cipher-format';

export const isCipher = (value: unknown): value is string =>
    typeof value === 'string' && value.startsWith(CIPHER_PREFIX);
